import { render, staticRenderFns } from "./AddEditVacationDays.vue?vue&type=template&id=c124e748&scoped=true"
import script from "./AddEditVacationDays.vue?vue&type=script&lang=js"
export * from "./AddEditVacationDays.vue?vue&type=script&lang=js"
import style0 from "./AddEditVacationDays.vue?vue&type=style&index=0&id=c124e748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c124e748",
  null
  
)

export default component.exports